import { Heading, Text } from "@otrium/atoms";
import styles from "./PromotionBanner.module.scss";
import { Box, Flex } from "@otrium/core";
import { CSSProperties, FC } from "react";
import { PromotionBannerProps } from "./PromotionBannerTypes";
import { PromotionBannerImage } from "./PromotionBannerImage";

const PromotionBannerTypeOne: FC<PromotionBannerProps> = ({
  images,
  title,
  description,
  buttonTitle,
  buttonColor,
  buttonTextColor,
  backgroundColor,
  conditionText,
  hideCTAButton,
  titleColor,
  textColor,
  priority,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <PromotionBannerImage
        images={images}
        alt={title}
        sizes="100vw"
        priority={priority}
      />
      <div className={styles.contentWrapper}>
        <Flex
          flexDirection="column"
          alignItems="center"
          mt={["space32", "space32", "12px", "20px"]}
          paddingX={["space16", "space0", "space0", "space0"]}
        >
          <Heading
            as="h1"
            className={styles.bannerHeading}
            color={titleColor || "tone.white"}
            fontWeight="700"
          >
            {title}
          </Heading>
          {description && (
            <Text
              fontSize={["fontSize18", "fontSize18", "22px"]}
              lineHeight={["24px", "24px", "32px"]}
              textAlign="center"
              color={textColor || "tone.white"}
              mb="space16"
            >
              {description}
            </Text>
          )}
          {!hideCTAButton ? (
            <div
              className={styles.fakeButton}
              style={
                {
                  "--banner-button-color": buttonTextColor,
                  "--banner-button-bg": buttonColor,
                } as CSSProperties
              }
            >
              {buttonTitle}
            </div>
          ) : null}
          {conditionText && (
            <Text fontSize={"fontSize12"} color={textColor || "tone.white"}>
              {conditionText}
            </Text>
          )}
        </Flex>
      </div>
    </Box>
  );
};

export default PromotionBannerTypeOne;
